/* eslint-disable */
export default {
  unknown: '不明',
  multipleMatches: '複数の一致',
  anonymous: '匿名',
  none: 'なし',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"multipleMatches"@#@ @source: @#@"Multiple matches"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"none"@#@ @source: @#@"None"@#@
